import {connect} from 'react-redux';

import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../srcCommon/helpers/reselectHelpers';
import {DraftMessageModel} from '../../../../../../models/api/messageModel';
import {ReplyLocationsEnum} from '../../../../../../services/tracking';
import {AppState} from '../../../../../../store/appState';
import {getChannels} from '../../../../../../store/data/channels/channelsSelectors';
import {forwardDraftInNewConversationAction} from '../../../../../../store/data/messages/draftMessagesActions';
import {makeGetIsMessageVisuallyShared} from '../../../../../../store/data/messages/messagesSelectors';
import {
  ComposerPanelId,
  EmlPanelId,
  MessagePanelId,
  ViewerPanelId,
} from '../../../../../../store/panels/panelStateBase';
import {PrivateReplyTooltipCoordinator} from './privateReplyTooltipCoordinator';

/*
 * Props.
 */

interface StartPrivateConversationContainerProps {
  location: ReplyLocationsEnum;
  message: DraftMessageModel;
  panelId: ComposerPanelId | ViewerPanelId | MessagePanelId | EmlPanelId;
  isPopup: boolean;
}

/*
 * Selectors.
 */

function getDraft(_state: AppState, props: StartPrivateConversationContainerProps) {
  return props.message;
}

/**
 * For event tracking purposes, we want the channel in which the draft lives and may potentially be sent from.
 */
function getChannelId(_state: AppState, props: StartPrivateConversationContainerProps): number {
  return props.message.fromChannelId;
}

function makeGetChannelNamespace() {
  return createSelector(
    [getChannels, getChannelId],
    (channels, channelId): string | undefined => channels[channelId]?.namespace,
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<StartPrivateConversationContainerProps>()(() => ({
  channelNamespace: makeGetChannelNamespace(),
  isSharedDraft: makeGetIsMessageVisuallyShared(getDraft),
}));

const mapDispatchToProps = makeMapDispatchToProps<StartPrivateConversationContainerProps>()(
  ({location, message, panelId}) => ({
    onStartPrivateConversationClick: () =>
      forwardDraftInNewConversationAction(panelId, message.uid, location),
  }),
);

export const PrivateReplyTooltipCoordinatorContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrivateReplyTooltipCoordinator);
